export type Language = 'pt-BR' | 'en-US' | 'es';

const ptBR = {
    // Navigation
    'nav.menu': 'Menu Inicial',
    'nav.lancarReceitas': 'Lançar Receitas',
    'nav.lancarDespesas': 'Lançar Despesas',
    'nav.historico': 'Histórico de Lançamentos',
    'nav.importarPlanilha': 'Importar Planilha',
    'nav.cashflow': 'Fluxo de Caixa',
    'nav.graficos': 'Gráficos',
    'nav.relatorios': 'Relatórios',
    'nav.planoContas': 'Plano de Contas',
    'nav.configuracoes': 'Configurações',
    'nav.ganhe': 'Ganhe 1 Mês Grátis',
    'nav.ajuda': 'Ajuda & Suporte',
    'nav.gestaoUsuarios': 'Gestão de Usuários',
    'nav.filialAtiva': 'Negócio ativo',
    'nav.selecionarFilial': 'Selecionar negócio',
    'nav.expandirMenu': 'Expandir menu',
    'nav.recolherMenu': 'Recolher menu',
    'nav.fecharMenu': 'Fechar menu',
    'nav.abrirMenu': 'Abrir menu',
    // Header dropdown
    'header.configuracoes': 'Configurações',
    'header.sair': 'Sair',
    'header.negocio': 'Negócio',
    'header.somenteVisualizacao': 'Somente visualização',
    'header.trocarNegocio': 'Trocar de negócio',
    'header.todosNegocios': 'Todos os negócios',
    'header.selecionarNegocio': 'Selecionar',
    //Cashflow
    'cashflow.subtituloTabela': 'Entradas e saídas agrupadas por categoria',
    'cashflow.scrollHint': 'Role a tabela para o lado para ver todos os meses',
    'cashflow.periodoExibido': 'Período exibido',
    'cashflow.anoInteiro': 'Ano inteiro',
    'cashflow.compararMesAnterior': 'Comparar com mês anterior',
    'cashflow.mostrarMesesZerados': 'Mostrar meses zerados',
    'cashflow.analiseHorizontal': 'Análise horizontal (% da receita)',
    'cashflow.exportarPdf': 'Exportar PDF',
    'cashflow.exportarExcel': 'Exportar Excel',
    'cashflow.semMovimento': 'Nenhum mês com movimentação neste ano.',
    'cashflow.notaAnaliseHorizontal': 'A análise horizontal mostra cada valor como percentual das entradas do mesmo mês; mês sem entrada aparece como "–".',
    'cashflow.notaComparacao': 'Δ% compara cada mês com o anterior. Janeiro fica sem comparação porque o mês anterior está fora do ano consultado, e mês com base zero também.',
    'cashflow.notaMesesOcultos': '{{n}} mês(es) sem movimentação ocultos.',
    // Common
    'common.carregando': 'Carregando...',
    'common.ilimitado': 'Ilimitado',
    'common.salvando': 'Salvando...',
    'common.cancelar': 'Cancelar',
    'common.fechar': 'Fechar',
    'common.limpar': 'Limpar',
    'common.confirmar': 'Confirmar',
    'common.voltar': 'Voltar',
    'common.salvar': 'Salvar',
    'common.salvarAlteracoes': 'Salvar Alterações',
    'common.editar': 'Editar',
    'common.excluir': 'Excluir',
    'common.adicionar': 'Adicionar',
    'common.selecione': 'Selecione...',
    'common.sim': 'Sim',
    'common.nao': 'Não',
    'common.acoes': 'Ações',
    'common.nome': 'Nome',
    'common.tipo': 'Tipo',
    'common.descricao': 'Descrição',
    'common.status': 'Status',
    'common.ativo': 'Ativo',
    'common.inativo': 'Inativo',
    'common.entrada': 'Entrada',
    'common.saida': 'Saída',
    'common.ambos': 'Ambos',
    'common.verMais': 'ver mais',
    'common.semResultados': 'Nenhum resultado encontrado.',
    'common.erroCampos': 'Preencha todos os campos obrigatórios',
    'common.erroCarregar': 'Não foi possível carregar os dados. Tente novamente em instantes.',
    'common.ano': 'Ano',
    'common.anoAtual': 'Ano atual',
    // Login
    'login.titulo': 'Bem-vindo de volta!',
    'login.subtitulo': 'Entre com suas credenciais para acessar sua conta',
    'login.email': 'E-mail',
    'login.senha': 'Senha',
    'login.entrar': 'Entrar',
    'login.esqueceuSenha': 'Esqueceu a senha?',
    'login.semConta': 'Não tem uma conta?',
    'login.cadastrar': 'Cadastre-se grátis',
    'login.erroCampos': 'Por favor, preencha todos os campos.',
    'login.erroCredenciais': 'Credenciais inválidas. Tente novamente.',
    'login.voltarLogin': 'Voltar para o login',
    'login.forgotTitulo': 'Redefinir senha',
    'login.forgotSubtitulo': 'Informe seu e-mail para receber o link de redefinição',
    'login.forgotEnviar': 'Enviar link',
    'login.forgotSucesso': 'Se este e-mail estiver cadastrado, você receberá um link para redefinir sua senha em breve.',
    'login.forgotEmailObrigatorio': 'Por favor, informe seu e-mail.',
    'login.forgotErro': 'Erro ao enviar o e-mail. Tente novamente.',
    // ResetPassword
    'resetPassword.titulo': 'Nova senha',
    'resetPassword.subtitulo': 'Crie uma nova senha para sua conta',
    'resetPassword.novaSenha': 'Nova senha',
    'resetPassword.confirmarSenha': 'Confirmar nova senha',
    'resetPassword.salvar': 'Salvar nova senha',
    'resetPassword.sucesso': 'Senha redefinida com sucesso! Você já pode fazer login.',
    'resetPassword.erroCampos': 'Por favor, preencha todos os campos.',
    'resetPassword.erroSenhasDiferentes': 'As senhas não coincidem.',
    'resetPassword.erroSenhaFraca': 'A senha deve ter no mínimo 6 caracteres.',
    'resetPassword.erroTokenInvalido': 'Link de redefinição inválido.',
    'resetPassword.erroTokenExpirado': 'Este link expirou ou já foi utilizado. Solicite um novo.',
    // Register
    'register.titulo': 'Crie sua conta',
    'register.subtitulo': 'Preencha os dados abaixo para começar',
    'register.nomeCompleto': 'Nome completo',
    'register.email': 'E-mail',
    'register.whatsapp': 'WhatsApp',
    'register.whatsappHint': 'Com código do país + DDD + número (somente dígitos). Ex: 5511999998888',
    'register.senha': 'Senha',
    'register.confirmarSenha': 'Confirmar senha',
    'register.criar': 'Criar conta',
    'register.temConta': 'Já tem uma conta?',
    'register.entrar': 'Entrar',
    'register.erroCampos': 'Por favor, preencha todos os campos.',
    'register.erroSenhasCoincidem': 'As senhas não coincidem.',
    'register.erroSenhaMin': 'A senha deve ter no mínimo 6 caracteres.',
    'register.erroWhatsapp': 'Informe o WhatsApp com código do país + DDD + número (somente dígitos, ex: 5511999998888).',
    'register.erroEmailExiste': 'Este e-mail já está cadastrado.',
    'register.erroGenerico': 'Erro ao criar conta. Tente novamente.',
    'register.erroNomeObrigatorio': 'Informe seu nome completo.',
    'register.erroNomeInvalido': 'Informe um nome válido (apenas letras e espaços).',
    'register.erroEmailObrigatorio': 'Informe seu e-mail.',
    'register.erroEmailInvalido': 'Informe um e-mail válido.',
    'register.erroWhatsappObrigatorio': 'Informe seu número de WhatsApp.',
    'register.erroWhatsappInvalido': 'Este número de WhatsApp parece inválido. Verifique o código do país e do DDD.',
    'register.erroSenhaObrigatoria': 'Crie uma senha.',
    'register.erroSenhaFraca': 'Sua senha ainda não atende a todos os requisitos abaixo.',
    'register.erroConfirmarSenhaObrigatoria': 'Confirme sua senha.',
    'register.mostrarSenha': 'Mostrar senha',
    'register.ocultarSenha': 'Ocultar senha',
    'register.senhaReqMinLength': 'Mínimo de 8 caracteres',
    'register.senhaReqUppercase': 'Uma letra maiúscula',
    'register.senhaReqLowercase': 'Uma letra minúscula',
    'register.senhaReqNumber': 'Um número',
    'register.senhaReqSpecial': 'Um caractere especial',
    'register.emailPlaceholder': 'seu.email@exemplo.com',
    'home.titulo': 'Início',
    'home.saudacao': 'Olá {{name}}, o que vamos fazer agora?',
    'home.lancar': 'Lançar',
    'home.receitas': 'Receitas',
    'home.despesas': 'Despesas',
    'home.historico': 'Histórico de Lançamentos',
    'home.cashflow': 'Fluxo de Caixa',
    'home.graficos': 'Gráficos',
    'home.relatorios': 'Relatórios',
    // Lançar Receita
    'receita.titulo': 'Lançar Receita',
    'receita.subtitulo': 'Registre suas entradas financeiras',
    'receita.dataRecebimento': 'Data de Recebimento',
    'receita.tipo': 'Tipo de Receita',
    'receita.formaPagamento': 'Forma de Pagamento',
    'receita.valor': 'Valor Total',
    'receita.infoAdicionais': 'Informações Adicionais',
    'receita.placeholder': 'Observações, detalhes do lançamento...',
    'receita.btn': 'Lançar Receita',
    'receita.sucesso': 'Receita lançada com sucesso!',
    'receita.erroSalvar': 'Erro ao salvar lançamento. Tente novamente.',
    // Lançar Despesa
    'despesa.titulo': 'Lançar Despesa',
    'despesa.subtitulo': 'Registre suas saídas financeiras',

    // Plano Gratuito (MAN-364)
    'planoGratuito.contagemTitulo': 'Você está no plano Gratuito com {{limite}} lançamentos',
    'planoGratuito.contagem': 'Contagem ({{usados}}/{{limite}})',
    'planoGratuito.limiteTitulo': 'Você atingiu o limite de lançamentos!',
    'planoGratuito.limitePrefixo': 'Seu',
    'planoGratuito.limiteDestaque': 'limite é de {{limite}} lançamentos',
    'planoGratuito.limiteSufixo': '.',
    'planoGratuito.limiteModal': 'Seu limite é de {{limite}} lançamentos, faça o upgrade para mais.',
    'planoGratuito.fazerUpgrade': 'Fazer Upgrade',
    'planoGratuito.fechar': 'Fechar aviso',
    'despesa.dataPagamento': 'Data de Pagamento',
    'despesa.tipo': 'Tipo de Despesa',
    'despesa.btn': 'Lançar Despesa',
    'despesa.sucesso': 'Despesa lançada com sucesso!',
    'despesa.erroSalvar': 'Erro ao salvar lançamento. Tente novamente.',
    // Lançamentos (histórico)
    'lanc.titulo': 'Histórico de Lançamentos',
    'lanc.subtitulo': 'Gerencie e visualize todos os seus lançamentos',
    'lanc.todos': 'Todos',
    'lanc.receitas': 'Receitas',
    'lanc.despesas': 'Despesas',
    'lanc.data': 'Data',
    'lanc.categoria': 'Categoria',
    'lanc.tipo': 'Tipo',
    'lanc.grupo': 'Grupo',
    'lanc.buscarCategoriaOuGrupo': 'Buscar categoria ou grupo...',
    'lanc.tipoLancamento': 'Tipo',
    'lanc.todosGrupos': 'Todos os grupos',
    'lanc.buscarCategoria': 'Buscar por categoria...',
    'lanc.formaPag': 'Forma de Pag.',
    'lanc.valor': 'Valor',
    'lanc.obs': 'Obs.',
    'lanc.descricao': 'Descrição',
    'lanc.lancadoPor': 'Lançado por',
    'lanc.dataDe': 'De',
    'lanc.dataAte': 'Até',
    'lanc.receita': 'Receita',
    'lanc.gasto': 'Gasto',
    'lanc.totalReceitas': 'Total Receitas',
    'lanc.totalGastos': 'Total Gastos',
    'lanc.resultado': 'Resultado',
    'lanc.lancamentos': 'Lançamentos',
    'lanc.novoLancamento': 'Novo Lançamento',
    'lanc.editarLancamento': 'Editar Lançamento',
    'lanc.confirmarExcluir': 'Tem certeza que deseja excluir este lançamento?',
    'lanc.erroSalvar': 'Erro ao salvar lançamento',
    'lanc.erroExcluir': 'Erro ao excluir lançamento',
    'lanc.erroCarregar': 'Não foi possível carregar os lançamentos. Tente novamente em instantes.',
    'lanc.buscarSubcategoria': 'Buscar por subcategoria...',
    'lanc.todasCategorias': 'Todas categorias',
    'lanc.todosMeses': 'Todos os meses',
    'lanc.todosAnos': 'Todos os anos',
    'lanc.filial': 'Negócio',
    'lanc.nenhumEncontrado': 'Nenhum lançamento encontrado',
    'lanc.observacao': 'Observação',
    'lanc.formaPagEx': 'Ex: PIX, Cartão de Crédito...',
    'lanc.obsPlaceholder': 'Observações sobre o lançamento...',
    'lanc.cadastrar': 'Cadastrar',
    'lanc.ordenarPorCriacao': 'Por cadastro',
    'lanc.ordenarPorData': 'Por data de lançamento',
    // Plano de Contas
    'plano.titulo': 'Plano de Contas',
    'plano.subtitulo': 'Gerencie grupos, categorias e formas de pagamento',
    'plano.faixaEmpresa': 'Plano de contas da empresa {{empresa}}',
    'plano.grupos': 'Grupos',
    'plano.novoGrupo': 'Novo grupo',
    'plano.editarGrupo': 'Editar grupo',
    'plano.grupoVinculado': 'Grupo',
    'plano.pesquisarGrupo': 'Pesquisar grupo...',
    'plano.receitas': 'Receitas',
    'plano.despesas': 'Despesas',
    'plano.catCount': '{{n}} categoria',
    'plano.catCount_plural': '{{n}} categorias',
    'plano.grupoCount': '{{n}} grupo',
    'plano.grupoCount_plural': '{{n}} grupos',
    'plano.resumoSecao': '{{cat}} em {{grp}}',
    'plano.nenhumGrupo': 'Nenhum grupo cadastrado',
    'plano.criarPrimeiroGrupo': 'Criar primeiro grupo',
    'plano.nenhumaCatNoGrupo': 'Nenhuma categoria neste grupo',
    'plano.organizarGrupos': 'Organizar grupos',
    'plano.organizarAjuda': 'Arraste as categorias para movê-las entre os grupos. Só é possível mover dentro de receitas ou dentro de despesas.',
    'plano.soltarAqui': 'Solte aqui para mover para este grupo',
    'plano.tipoIncompativel': 'Só é possível mover categorias entre grupos do mesmo tipo (receitas ou despesas).',
    'plano.pendentes': '{{n}} alteração não salva',
    'plano.pendentes_plural': '{{n}} alterações não salvas',
    'plano.salvarOrganizacao': 'Salvar organização',
    'plano.descartarOrganizacao': 'Descartar',
    'plano.organizacaoSalva': 'Organização salva. O Fluxo de Caixa já reflete os novos grupos.',
    'plano.erroMover': 'Não foi possível salvar a organização.',
    'plano.confirmarSairSemSalvar': 'Você organizou os grupos mas ainda não salvou. Deseja salvar agora?',
    'plano.confirmarDescartar': 'Descartar as alterações de organização?',
    'plano.categorias': 'Categorias',
    'plano.formasPagamento': 'Formas de Pagamento',
    'plano.novaCategoria': 'Nova Categoria',
    'plano.novaFormaPagamento': 'Nova Forma de Pagamento',
    'plano.editarCategoria': 'Editar Categoria',
    'plano.editarFormaPagamento': 'Editar Forma de Pagamento',
    'plano.nomeCategoria': 'Nome da Categoria',
    'plano.nomeFormaPagamento': 'Nome da Forma de Pagamento',
    'plano.confirmarExcluir': 'Tem certeza que deseja excluir este item?',
    'plano.confirmarExcluirGrupo': 'Excluir o grupo "{{nome}}" também exclui as {{n}} categoria(s) dentro dele. Deseja continuar?',
    'plano.erroSalvar': 'Erro ao salvar. Verifique os dados e tente novamente.',
    'plano.erroExcluir': 'Erro ao excluir. Este item pode estar em uso.',
    'plano.naoExcluirVinculado': 'Não é possível excluir "{{nome}}": há {{n}} lançamento(s) vinculado(s). Você pode renomear (o nome será atualizado nos lançamentos), mas não excluir.',
    'plano.exclusaoBloqueada': 'Exclusão bloqueada: há lançamentos vinculados. Você pode renomear.',
    'plano.vinculadosInfo': 'Este item possui {{n}} lançamento(s) vinculado(s). Alterar o nome atualizará todos eles.',
    'plano.entradas': 'Entradas',
    'plano.saidas': 'Saídas',
    'plano.descricaoOpcional': 'Descrição (opcional)',
    // Fluxo de Caixa
    'cashflow.titulo': 'Fluxo de Caixa',
    'cashflow.subtitulo': 'Demonstração do Resultado do Exercício',
    'cashflow.dataInicio': 'Data início',
    'cashflow.dataFim': 'Data fim',
    'cashflow.aplicar': 'Aplicar',
    // Settings
    'settings.titulo': 'Configurações',
    'settings.subtitulo': 'Gerencie suas preferências e informações da conta',
    'settings.perfil': 'Perfil',
    'settings.preferencias': 'Preferências',
    'settings.notificacoes': 'Notificações',
    'settings.seguranca': 'Segurança',
    'settings.assinatura': 'Assinatura',
    'settings.historicoPagamentos': 'Histórico de Pagamentos',
    'settings.infosPerfil': 'Informações do Perfil',
    'settings.nomeCompleto': 'Nome completo',
    'settings.prefsSalvas': '✓ Preferências salvas automaticamente.',
    'settings.modoEscuro': 'Modo Escuro',
    'settings.modoEscuroDesc': 'Ative o tema escuro para melhor visualização noturna',
    'settings.moedaPadrao': 'Moeda Padrão',
    'settings.moedaPadraoDesc': 'Selecione a moeda para exibição dos valores',
    'settings.idioma': 'Idioma',
    'settings.idiomaDesc': 'Selecione o idioma da interface',
    'settings.primeiroDia': 'Primeiro dia da semana',
    'settings.primeiroDiaDesc': 'Defina o primeiro dia da semana para os calendários',
    'settings.domingo': 'Domingo',
    'settings.segunda': 'Segunda-feira',
    'settings.prefSistema': 'Preferências do Sistema',
    'settings.segConta': 'Segurança da Conta',
    'settings.senhaAtual': 'Senha Atual',
    'settings.novaSenha': 'Nova Senha',
    'settings.confirmarSenha': 'Confirmar Nova Senha',
    'settings.alterarSenha': 'Alterar Senha',
    'settings.alterando': 'Alterando...',
    'settings.suporteTitle': 'Precisa de ajuda?',
    'settings.suporteDesc': 'Nossa equipe está disponível para te atender pelo WhatsApp.',
    'settings.falarComSuporte': 'Falar com suporte',
    'help.titulo': 'Ajuda e Suporte',
    'help.subtitulo': 'Aprenda no seu ritmo ou fale com a gente.',
    'help.videosTag': 'Vídeos',
    'help.videosTitulo': 'Tutoriais no YouTube',
    'help.videosDesc': 'Veja o passo a passo de cada tela do Financeiro Diário.',
    'help.videosBotao': 'Assistir tutoriais',
    'help.comunidadeTag': 'Comunidade',
    'help.comunidadeTitulo': 'Comunidade do Financeiro Diário',
    'help.comunidadeDesc': 'Tire dúvidas e veja como outras pessoas organizam o dinheiro do negócio.',
    'help.comunidadeBotao': 'Entrar na comunidade',
    'help.suporteTag': 'Atendimento',
    'help.suporteTitulo': 'Suporte',
    'help.suporteDesc': 'Não achou a resposta? Chame a equipe no WhatsApp.',
    'help.suporteBotao': 'Falar com o suporte',
    'settings.notifEmail': 'Notificações por E-mail',
    'settings.notifEmailDesc': 'Receba atualizações importantes no seu e-mail',
    'settings.notifPush': 'Notificações Push',
    'settings.notifPushDesc': 'Receba notificações no navegador',
    'settings.relSemanal': 'Relatório Semanal',
    'settings.relSemanalDesc': 'Receba um resumo semanal das suas finanças',
    'settings.alertasOrc': 'Alertas de Orçamento',
    'settings.alertasOrcDesc': 'Seja notificado quando atingir limites de orçamento',
    'settings.notifConfig': 'Configurações de Notificações',
    'settings.notifSalvas': '✓ Preferências de notificação salvas.',
    // Settings - dynamic messages
    'settings.nomeObrigatorio': 'Nome é obrigatório.',
    'settings.emailObrigatorio': 'E-mail é obrigatório.',
    'settings.emailInvalido': 'Informe um e-mail válido.',
    'settings.perfilSalvo': 'Perfil atualizado com sucesso.',
    'settings.erroSalvarPerfil': 'Erro ao salvar perfil.',
    'settings.preencherCampos': 'Preencha todos os campos.',
    'settings.senhaMinCarac': 'A nova senha deve ter no mínimo 6 caracteres.',
    'settings.senhasNaoCoincidem': 'As senhas não coincidem.',
    'settings.senhaAlterada': 'Senha alterada com sucesso.',
    'settings.erroAlterarSenha': 'Erro ao alterar senha.',
    'settings.erroExcluirConta': 'Erro ao excluir conta.',
    // Settings - security danger zone
    'settings.zonaDangerTitle': 'Zona de Perigo',
    'settings.zonaDangerDesc': 'Ações irreversíveis que afetam permanentemente sua conta.',
    'settings.excluirConta': 'Excluir minha conta',
    'settings.excluirContaAviso': 'Digite',
    'settings.excluirContaAvisoApos': 'para confirmar a exclusão permanente da sua conta:',
    'settings.excluirConfirmar': 'Confirmar Exclusão',
    'settings.excluindo': 'Excluindo...',
    // Settings - subscription
    'settings.suaAssinatura': 'Sua Assinatura',
    'settings.planoAtual': 'Plano Atual',
    'settings.semPlanoAtivo': 'Sem plano ativo',
    'settings.cobMensal': 'Cobrança mensal',
    'settings.cobAnual': 'Cobrança anual',
    'settings.mes': 'mês',
    'settings.ano': 'ano',
    'settings.transacoesPorMes': 'Transações por mês',
    'settings.funcionalidades': 'Funcionalidades',
    'settings.cancelarAssinatura': 'Cancelar Assinatura',
    'settings.cancelarAssinaturaDesc': 'Ao cancelar, você perderá acesso aos recursos premium ao final do período atual.',
    'settings.solicitarCancelamento': 'Solicitar Cancelamento',
    // Settings - payments
    'settings.totalPago': 'Total pago',
    'settings.faturasPagas': 'Faturas pagas',
    'settings.statusConta': 'Status da conta',
    'settings.emDia': 'Em dia',
    'settings.semPlano': 'Sem plano',
    'settings.historicoVazio': 'O histórico detalhado de faturas será exibido aqui quando disponível pela operadora de pagamentos.',
    'settings.dadosFiscais': 'Dados Fiscais',
    'settings.nomeRazaoSocial': 'Nome/Razão Social',
    'settings.endereco': 'Endereço',
    'settings.cep': 'CEP',
    'settings.salvarDadosFiscais': 'Salvar Dados Fiscais',
    'settings.dadosFiscaisSalvos': 'Dados fiscais salvos localmente.',
    // Common pagination / search
    'common.anterior': 'Anterior',
    'common.proxima': 'Próxima',
    'common.pagina': 'Página',
    'common.de': 'de',
    'common.buscar': 'Buscar',
    'common.buscando': 'Buscando...',
    'common.semDados': 'Sem dados no período',
    'common.carregandoDados': 'Carregando dados...',
    'common.periodo': 'Período',
    'common.ate': 'até',
    'common.categoria': 'Categoria',
    'common.saldo': 'Saldo',
    // Charts / Dashboard components
    'chart.fluxoCaixa': 'Fluxo de Caixa',
    'chart.ultimos6Meses': 'Últimos 6 meses',
    'chart.ultimoAno': 'Último ano',
    'chart.todoPeriodo': 'Todo o período',
    'chart.tudo': 'Tudo',
    'chart.receitas': 'Receitas',
    'chart.despesas': 'Despesas',
    'chart.semDadosFluxo': 'Sem dados de fluxo de caixa no período',
    'chart.resultadoMensal': 'Resultado Mensal',
    'chart.receitaMinusDespesa': 'Receita − Despesa por mês',
    'chart.resultado': 'Resultado',
    'chart.comparativoMensal': 'Comparativo Mensal',
    'chart.receitasVsDespesas': 'Receitas vs Despesas por mês',
    'chart.distribuicaoDespesas': 'Distribuição de Despesas',
    'chart.distribuicaoReceitas': 'Distribuição de Receitas',
    'chart.porCategoria': 'Por categoria',
    'chart.outros': 'Outros',
    'chart.verMenos': 'Ver menos',
    'chart.verTodas': 'Ver todas',
    'chart.topCategorias': 'Top Categorias de Gastos',
    'chart.maioresDespesas': 'Maiores despesas por categoria',
    'chart.topReceitas': 'Top Categorias de Receitas',
    'chart.maioresReceitas': 'Maiores receitas por categoria',
    'chart.fluxoAcumulado': 'Fluxo Acumulado',
    'chart.evolucaoResultado': 'Evolução do resultado ao longo do período',
    'chart.saldoAcumulado': 'Saldo Acumulado',
    'chart.positivo': 'Positivo',
    'chart.negativo': 'Negativo',
    // Recent Transactions
    'rt.transacoesRecentes': 'Transações Recentes',
    'rt.verTodas': 'Ver todas',
    'rt.nenhumaTransacao': 'Nenhuma transação recente.',
    'rt.todasTransacoes': 'Todas as Transações',
    'rt.buscarPlaceholder': 'Buscar por valor, categoria, forma de pagamento...',
    'rt.transacoesEncontradas': '{{n}} transação(ões) encontrada(s)',
    'rt.nenhumaTrEncontrada': 'Nenhuma transação encontrada.',
    'rt.hoje': 'Hoje',
    'rt.ontem': 'Ontem',
    // Reports
    'rel.titulo': 'Relatórios',
    'rel.subtitulo': 'Gere e exporte relatórios detalhados',
    'rel.exportarExcel': 'Exportar Excel',
    'rel.exportarPdf': 'Exportar PDF',
    'rel.filtros': 'Filtros do Relatório',
    'rel.tipoRelatorio': 'Tipo de Relatório',
    'rel.granularidade': 'Granularidade',
    'rel.dia': 'Dia',
    'rel.mes': 'Mês',
    'rel.ano': 'Ano',
    'rel.dataInicio': 'Data Início',
    'rel.dataFim': 'Data Fim',
    'rel.categoria': 'Categoria',
    'rel.grupo': 'Grupo',
    'rel.formaPagamento': 'Forma de Pagamento',
    'rel.todas': 'Todas',
    'rel.gerarRelatorio': 'Gerar Relatório',
    'rel.filiais': 'Negócios:',
    'rel.limpar': 'Limpar ({{n}})',
    'rel.totalReceitas': 'Total Receitas',
    'rel.totalDespesas': 'Total Despesas',
    'rel.resultadoLiquido': 'Resultado Líquido',
    'rel.transacoes': 'Transações',
    'rel.vsPeriodo': 'vs período anterior',
    'rel.nenhumDado': 'Nenhum dado encontrado para o período.',
    'rel.dicaForaPeriodo': 'Existem {{n}} lançamentos com esses filtros fora do período selecionado.',
    'rel.dicaNomeParecido': 'No período há lançamentos em categorias de nome parecido:',
    'rel.dicaQtdLancamentos': '{{n}} lançamentos',
    'rel.distribuicao': 'Distribuição',
    'rel.total': 'Total:',
    'rel.detalhamentoPorFilial': 'Detalhamento por Negócio',
    'rel.pctTotal': '% do total',
    'rel.detalhamento': 'Detalhamento',
    'rel.evolucaoFluxo': 'Evolução do Fluxo de Caixa',
    'rel.porPeriodo': 'Por período',
    'rel.resumoPeriodo': 'Resumo do Período',
    'rel.resultadoFinal': 'Resultado Final',
    'rel.evolucaoResultado': 'Evolução do Resultado',
    'rel.principaisCategorias': 'Principais Categorias',
    'rel.subtotalReceitas': 'Subtotal Receitas',
    'rel.subtotalDespesas': 'Subtotal Despesas',
    'rel.outrasCategorias': 'Outros ({{n}})',
    'rel.principaisReceitas': 'Principais Receitas',
    'rel.principaisDespesas': 'Principais Despesas',
    'rel.porValor': 'por valor',
    'rel.gerandoRelatorio': 'Gerando relatório...',
    'rel.errGerar': 'Erro ao gerar relatório. Tente novamente.',
    'rel.metrica': 'Métrica',
    'rel.valor': 'Valor',
    'rel.fonte': 'Fonte',
    'rel.type.monthlySummary': 'Resumo Mensal',
    'rel.type.monthlySummaryDesc': 'Visão geral do período',
    'rel.type.expByCategory': 'Despesas por Categoria',
    'rel.type.expByCategoryDesc': 'Análise de despesas',
    'rel.type.incBySource': 'Receitas por Fonte',
    'rel.type.incBySourceDesc': 'Análise de receitas',
    'rel.type.cashflow': 'Fluxo de Caixa',
    'rel.type.cashflowDesc': 'Movimentação financeira',
    'rel.type.incByFilial': 'Receitas por Negócio',
    'rel.type.incByFilialDesc': 'Receitas agrupadas por negócio',
    'rel.type.expByFilial': 'Despesas por Negócio',
    'rel.type.expByFilialDesc': 'Despesas agrupadas por negócio',
    // Plano de Contas — Grupos
    'cat.receitas': 'Receitas',
    'cat.custos': 'Custos',
    'cat.despesasVariaveis': 'Despesas Variáveis',
    'cat.despesasFixas': 'Despesas Fixas',
    'cat.outrasDespesas': 'Outras Despesas',
    // Plano de Contas — Categorias de Receita
    'sub.vendasProdutos': 'Vendas de Produtos',
    'sub.vendasServicos': 'Vendas de Serviços',
    'sub.investimento': 'Investimento',
    'sub.rendimentoAplicacoes': 'Rendimento de Aplicações',
    // Categorias de Custos
    'sub.materiaPrima': 'Matéria Prima',
    'sub.embalagem': 'Embalagem',
    'sub.insumos': 'Insumos',
    // Categorias de Despesas Variáveis
    'sub.impostos': 'Impostos',
    'sub.marketing': 'Gasto em anúncios de marketing',
    'sub.comissao': 'Comissão',
    'sub.servicoTerceiros': 'Serviço de terceiros',
    // Categorias de Despesas Fixas
    'sub.aluguel': 'Aluguel',
    'sub.luz': 'Luz',
    'sub.aguaEsgoto': 'Água e esgoto',
    'sub.internetTelefone': 'Internet e Telefone',
    'sub.folhaPagamento': 'Folha de pagamento',
    'sub.valeTransporte': 'Vale transporte',
    'sub.valeCombustivel': 'Vale Combustível',
    'sub.inss': 'INSS',
    'sub.fgts': 'FGTS',
    'sub.materialEscritorio': 'Material de Escritório',
    'sub.contabilidade': 'Contabilidade',
    'sub.proLabore': 'Pró-labore',
    // Categorias de Outras Despesas
    'sub.investimentos': 'Investimentos',
    'sub.tarifasBancarias': 'Tarifas Bancárias',
    'sub.juros': 'Juros',
    'sub.descontos': 'Descontos',
    // Formas de Pagamento
    'fp.pix': 'Pix',
    'fp.dinheiro': 'Dinheiro',
    'fp.transferenciaBancaria': 'Transferência Bancária',
    'fp.boleto': 'Boleto',
    'fp.cheque': 'Cheque',
    'fp.cartaoCredito': 'Cartão de Crédito',
    'fp.cartaoDebito': 'Cartão de Débito',
    'fp.duplicata': 'Duplicata',
    'fp.deposito': 'Depósito',
    'fp.acordoParcelado': 'Acordo Parcelado',
    'fp.notaPromissoria': 'Nota Promissória',
    'fp.debitoAutomatico': 'Débito Automático',
    'fp.cartaoCorporativo': 'Cartão Corporativo',
    'fp.paypalWise': 'PayPal Wise',
    'fp.depositoIdentificado': 'Depósito Identificado',
    'fp.depositoJudicial': 'Depósito Judicial',
    'modal.subcategoria.titulo': 'Nova Categoria',
    'modal.subcategoria.categoriaPai': 'Grupo',
    'modal.subcategoria.subcategoria': 'Categoria',
    'modal.subcategoria.novaCategoria': 'Nome do novo grupo',
    'modal.subcategoria.novaSubcategoria': 'Nome da nova categoria',
    'modal.subcategoria.selecionePesquise': 'Selecione ou pesquise...',
    'modal.subcategoria.carregando': 'Carregando...',
    'modal.subcategoria.concluir': 'Concluir',
    'modal.subcategoria.erroCategoria': 'Informe o nome do grupo.',
    'modal.subcategoria.erroSubcategoria': 'Informe o nome da categoria.',
    'modal.subcategoria.erroSelecao': 'Selecione o grupo e a categoria.',
    'modal.subcategoria.erroCarregarSubs': 'Erro ao carregar categorias.',
} as const;

const enUS: Record<keyof typeof ptBR, string> = {
    'nav.menu': 'Home',
    'nav.lancarReceitas': 'Record Income',
    'nav.lancarDespesas': 'Record Expenses',
    'nav.historico': 'Transaction History',
    'nav.importarPlanilha': 'Import Spreadsheet',
    'nav.cashflow': 'Cash Flow',
    'nav.graficos': 'Charts',
    'nav.relatorios': 'Reports',
    'nav.planoContas': 'Chart of Accounts',
    'nav.configuracoes': 'Settings',
    'nav.ganhe': 'Earn 1 Free Month',
    'nav.ajuda': 'Help & Support',
    'nav.gestaoUsuarios': 'User Management',
    'nav.filialAtiva': 'Active business',
    'nav.selecionarFilial': 'Select business',
    'nav.expandirMenu': 'Expand menu',
    'nav.recolherMenu': 'Collapse menu',
    'nav.fecharMenu': 'Close menu',
    'nav.abrirMenu': 'Open menu',
    'header.configuracoes': 'Settings',
    'header.sair': 'Sign Out',
    'header.negocio': 'Business',
    'header.somenteVisualizacao': 'View only',
    'header.trocarNegocio': 'Switch business',
    'header.todosNegocios': 'All businesses',
    'header.selecionarNegocio': 'Select',
    'cashflow.subtituloTabela': 'Income and expenses grouped by category',
    'cashflow.scrollHint': 'Scroll the table sideways to see all months',
    'cashflow.periodoExibido': 'Period shown',
    'cashflow.anoInteiro': 'Whole year',
    'cashflow.compararMesAnterior': 'Compare with previous month',
    'cashflow.mostrarMesesZerados': 'Show empty months',
    'cashflow.analiseHorizontal': 'Horizontal analysis (% of income)',
    'cashflow.exportarPdf': 'Export PDF',
    'cashflow.exportarExcel': 'Export Excel',
    'cashflow.semMovimento': 'No month with activity in this year.',
    'cashflow.notaAnaliseHorizontal': 'Horizontal analysis shows each value as a percentage of the same month income; a month without income shows "–".',
    'cashflow.notaComparacao': 'Δ% compares each month with the previous one. January has no comparison because the previous month is outside the selected year, nor does a month with a zero base.',
    'cashflow.notaMesesOcultos': '{{n}} month(s) without activity hidden.',
    'common.carregando': 'Loading...',
    'common.ilimitado': 'Unlimited',
    'common.salvando': 'Saving...',
    'common.cancelar': 'Cancel',
    'common.fechar': 'Close',
    'common.limpar': 'Clear',
    'common.confirmar': 'Confirm',
    'common.voltar': 'Back',
    'common.salvar': 'Save',
    'common.salvarAlteracoes': 'Save Changes',
    'common.editar': 'Edit',
    'common.excluir': 'Delete',
    'common.adicionar': 'Add',
    'common.selecione': 'Select...',
    'common.sim': 'Yes',
    'common.nao': 'No',
    'common.acoes': 'Actions',
    'common.nome': 'Name',
    'common.tipo': 'Type',
    'common.descricao': 'Description',
    'common.status': 'Status',
    'common.ativo': 'Active',
    'common.inativo': 'Inactive',
    'common.entrada': 'Income',
    'common.saida': 'Expense',
    'common.ambos': 'Both',
    'common.verMais': 'see more',
    'common.semResultados': 'No results found.',
    'common.erroCampos': 'Please fill in all required fields',
    'common.erroCarregar': 'Could not load the data. Please try again shortly.',
    'common.categoria': 'Category',
    'common.saldo': 'Balance',
    'common.ano': 'Year',
    'common.anoAtual': 'Current year',
    'login.titulo': 'Welcome back!',
    'login.subtitulo': 'Enter your credentials to access your account',
    'login.email': 'Email',
    'login.senha': 'Password',
    'login.entrar': 'Sign In',
    'login.esqueceuSenha': 'Forgot your password?',
    'login.semConta': "Don't have an account?",
    'login.cadastrar': 'Sign up for free',
    'login.erroCampos': 'Please fill in all fields.',
    'login.erroCredenciais': 'Invalid credentials. Please try again.',
    'login.voltarLogin': 'Back to login',
    'login.forgotTitulo': 'Reset password',
    'login.forgotSubtitulo': 'Enter your email to receive a reset link',
    'login.forgotEnviar': 'Send link',
    'login.forgotSucesso': 'If this email is registered, you will receive a reset link shortly.',
    'login.forgotEmailObrigatorio': 'Please enter your email.',
    'login.forgotErro': 'Error sending email. Please try again.',
    // ResetPassword
    'resetPassword.titulo': 'New password',
    'resetPassword.subtitulo': 'Create a new password for your account',
    'resetPassword.novaSenha': 'New password',
    'resetPassword.confirmarSenha': 'Confirm new password',
    'resetPassword.salvar': 'Save new password',
    'resetPassword.sucesso': 'Password reset successfully! You can now log in.',
    'resetPassword.erroCampos': 'Please fill in all fields.',
    'resetPassword.erroSenhasDiferentes': 'Passwords do not match.',
    'resetPassword.erroSenhaFraca': 'Password must be at least 6 characters.',
    'resetPassword.erroTokenInvalido': 'Invalid reset link.',
    'resetPassword.erroTokenExpirado': 'This link has expired or already been used. Please request a new one.',
    // Register
    'register.titulo': 'Create your account',
    'register.subtitulo': 'Fill in the details below to get started',
    'register.nomeCompleto': 'Full name',
    'register.email': 'Email',
    'register.whatsapp': 'WhatsApp',
    'register.whatsappHint': 'With country code + area code + number (digits only). Ex: 5511999998888',
    'register.senha': 'Password',
    'register.confirmarSenha': 'Confirm password',
    'register.criar': 'Create account',
    'register.temConta': 'Already have an account?',
    'register.entrar': 'Sign in',
    'register.erroCampos': 'Please fill in all fields.',
    'register.erroSenhasCoincidem': 'Passwords do not match.',
    'register.erroSenhaMin': 'Password must be at least 6 characters.',
    'register.erroWhatsapp': 'Enter WhatsApp with country code + area code + number (digits only, ex: 5511999998888).',
    'register.erroEmailExiste': 'This email is already registered.',
    'register.erroGenerico': 'Error creating account. Please try again.',
    'register.erroNomeObrigatorio': 'Enter your full name.',
    'register.erroNomeInvalido': 'Enter a valid name (letters and spaces only).',
    'register.erroEmailObrigatorio': 'Enter your email.',
    'register.erroEmailInvalido': 'Enter a valid email address.',
    'register.erroWhatsappObrigatorio': 'Enter your WhatsApp number.',
    'register.erroWhatsappInvalido': 'This WhatsApp number looks invalid. Check the country and area code.',
    'register.erroSenhaObrigatoria': 'Create a password.',
    'register.erroSenhaFraca': 'Your password does not meet all the requirements below yet.',
    'register.erroConfirmarSenhaObrigatoria': 'Confirm your password.',
    'register.mostrarSenha': 'Show password',
    'register.ocultarSenha': 'Hide password',
    'register.senhaReqMinLength': 'At least 8 characters',
    'register.senhaReqUppercase': 'One uppercase letter',
    'register.senhaReqLowercase': 'One lowercase letter',
    'register.senhaReqNumber': 'One number',
    'register.senhaReqSpecial': 'One special character',
    'register.emailPlaceholder': 'your.email@example.com',
    'home.titulo': 'Home',
    'home.saudacao': 'Hi {{name}}, what shall we do now?',
    'home.lancar': 'Record',
    'home.receitas': 'Income',
    'home.despesas': 'Expenses',
    'home.historico': 'Transaction History',
    'home.cashflow': 'Cash Flow',
    'home.graficos': 'Charts',
    'home.relatorios': 'Reports',
    'receita.titulo': 'Record Income',
    'receita.subtitulo': 'Register your financial income',
    'receita.dataRecebimento': 'Receipt Date',
    'receita.tipo': 'Income Type',
    'receita.formaPagamento': 'Payment Method',
    'receita.valor': 'Total Amount',
    'receita.infoAdicionais': 'Additional Information',
    'receita.placeholder': 'Notes, transaction details...',
    'receita.btn': 'Record Income',
    'receita.sucesso': 'Income recorded successfully!',
    'receita.erroSalvar': 'Error saving transaction. Please try again.',
    'despesa.titulo': 'Record Expense',
    'despesa.subtitulo': 'Register your financial expenses',

    // Plano Gratuito (MAN-364)
    'planoGratuito.contagemTitulo': 'You are on the Free plan with {{limite}} entries',
    'planoGratuito.contagem': 'Count ({{usados}}/{{limite}})',
    'planoGratuito.limiteTitulo': 'You have reached the entry limit!',
    'planoGratuito.limitePrefixo': 'Your',
    'planoGratuito.limiteDestaque': 'limit is {{limite}} entries',
    'planoGratuito.limiteSufixo': '.',
    'planoGratuito.limiteModal': 'Your limit is {{limite}} entries, upgrade to get more.',
    'planoGratuito.fazerUpgrade': 'Upgrade',
    'planoGratuito.fechar': 'Close notice',
    'despesa.dataPagamento': 'Payment Date',
    'despesa.tipo': 'Expense Type',
    'despesa.btn': 'Record Expense',
    'despesa.sucesso': 'Expense recorded successfully!',
    'despesa.erroSalvar': 'Error saving transaction. Please try again.',
    'lanc.titulo': 'Transaction History',
    'lanc.subtitulo': 'Manage and view all your transactions',
    'lanc.todos': 'All',
    'lanc.receitas': 'Income',
    'lanc.despesas': 'Expenses',
    'lanc.data': 'Date',
    'lanc.categoria': 'Category',
    'lanc.tipo': 'Type',
    'lanc.grupo': 'Group',
    'lanc.buscarCategoriaOuGrupo': 'Search category or group...',
    'lanc.tipoLancamento': 'Type',
    'lanc.todosGrupos': 'All groups',
    'lanc.buscarCategoria': 'Search by category...',
    'lanc.formaPag': 'Payment',
    'lanc.valor': 'Amount',
    'lanc.obs': 'Notes',
    'lanc.descricao': 'Description',
    'lanc.lancadoPor': 'Created by',
    'lanc.dataDe': 'From',
    'lanc.dataAte': 'To',
    'lanc.receita': 'Income',
    'lanc.gasto': 'Expense',
    'lanc.totalReceitas': 'Total Income',
    'lanc.totalGastos': 'Total Expenses',
    'lanc.resultado': 'Result',
    'lanc.lancamentos': 'Transactions',
    'lanc.novoLancamento': 'New Transaction',
    'lanc.editarLancamento': 'Edit Transaction',
    'lanc.confirmarExcluir': 'Are you sure you want to delete this transaction?',
    'lanc.erroSalvar': 'Error saving transaction',
    'lanc.erroExcluir': 'Error deleting transaction',
    'lanc.erroCarregar': 'Could not load transactions. Please try again shortly.',
    'lanc.buscarSubcategoria': 'Search by subcategory...',
    'lanc.todasCategorias': 'All categories',
    'lanc.todosMeses': 'All months',
    'lanc.todosAnos': 'All years',
    'lanc.filial': 'Business',
    'lanc.nenhumEncontrado': 'No transactions found',
    'lanc.observacao': 'Note',
    'lanc.formaPagEx': 'e.g. PIX, Credit Card...',
    'lanc.obsPlaceholder': 'Notes about the transaction...',
    'lanc.cadastrar': 'Create',
    'lanc.ordenarPorCriacao': 'By entry date',
    'lanc.ordenarPorData': 'By due date',
    'plano.titulo': 'Chart of Accounts',
    'plano.subtitulo': 'Manage groups, categories and payment methods',
    'plano.faixaEmpresa': 'Chart of accounts for {{empresa}}',
    'plano.grupos': 'Groups',
    'plano.novoGrupo': 'New group',
    'plano.editarGrupo': 'Edit group',
    'plano.grupoVinculado': 'Group',
    'plano.pesquisarGrupo': 'Search group...',
    'plano.receitas': 'Income',
    'plano.despesas': 'Expenses',
    'plano.catCount': '{{n}} category',
    'plano.catCount_plural': '{{n}} categories',
    'plano.grupoCount': '{{n}} group',
    'plano.grupoCount_plural': '{{n}} groups',
    'plano.resumoSecao': '{{cat}} in {{grp}}',
    'plano.nenhumGrupo': 'No groups registered',
    'plano.criarPrimeiroGrupo': 'Create first group',
    'plano.nenhumaCatNoGrupo': 'No categories in this group',
    'plano.organizarGrupos': 'Organize groups',
    'plano.organizarAjuda': 'Drag categories to move them between groups. Moves are only allowed within income or within expenses.',
    'plano.soltarAqui': 'Drop here to move into this group',
    'plano.tipoIncompativel': 'Categories can only be moved between groups of the same type (income or expenses).',
    'plano.pendentes': '{{n}} unsaved change',
    'plano.pendentes_plural': '{{n}} unsaved changes',
    'plano.salvarOrganizacao': 'Save layout',
    'plano.descartarOrganizacao': 'Discard',
    'plano.organizacaoSalva': 'Layout saved. Cash Flow now reflects the new groups.',
    'plano.erroMover': 'Could not save the layout.',
    'plano.confirmarSairSemSalvar': 'You reorganized the groups but have not saved yet. Save now?',
    'plano.confirmarDescartar': 'Discard the layout changes?',
    'plano.categorias': 'Categories',
    'plano.formasPagamento': 'Payment Methods',
    'plano.novaCategoria': 'New Category',
    'plano.novaFormaPagamento': 'New Payment Method',
    'plano.editarCategoria': 'Edit Category',
    'plano.editarFormaPagamento': 'Edit Payment Method',
    'plano.nomeCategoria': 'Category Name',
    'plano.nomeFormaPagamento': 'Payment Method Name',
    'plano.confirmarExcluir': 'Are you sure you want to delete this item?',
    'plano.confirmarExcluirGrupo': 'Deleting the group "{{nome}}" also deletes the {{n}} category(ies) inside it. Continue?',
    'plano.erroSalvar': 'Error saving. Please check the data and try again.',
    'plano.erroExcluir': 'Error deleting. This item may be in use.',
    'plano.naoExcluirVinculado': 'Cannot delete "{{nome}}": there are {{n}} linked transaction(s). You can rename it (the name will be updated in the transactions), but not delete it.',
    'plano.exclusaoBloqueada': 'Deletion blocked: there are linked transactions. You can rename it.',
    'plano.vinculadosInfo': 'This item has {{n}} linked transaction(s). Changing the name will update all of them.',
    'plano.entradas': 'Income',
    'plano.saidas': 'Expenses',
    'plano.descricaoOpcional': 'Description (optional)',
    'cashflow.titulo': 'Cash Flow',
    'cashflow.subtitulo': 'Income Statement',
    'cashflow.dataInicio': 'Start date',
    'cashflow.dataFim': 'End date',
    'cashflow.aplicar': 'Apply',
    'settings.titulo': 'Settings',
    'settings.subtitulo': 'Manage your preferences and account information',
    'settings.perfil': 'Profile',
    'settings.preferencias': 'Preferences',
    'settings.notificacoes': 'Notifications',
    'settings.seguranca': 'Security',
    'settings.assinatura': 'Subscription',
    'settings.historicoPagamentos': 'Payment History',
    'settings.infosPerfil': 'Profile Information',
    'settings.nomeCompleto': 'Full name',
    'settings.prefsSalvas': '✓ Preferences saved automatically.',
    'settings.modoEscuro': 'Dark Mode',
    'settings.modoEscuroDesc': 'Enable dark theme for better night-time viewing',
    'settings.moedaPadrao': 'Default Currency',
    'settings.moedaPadraoDesc': 'Select the currency for displaying values',
    'settings.idioma': 'Language',
    'settings.idiomaDesc': 'Select the interface language',
    'settings.primeiroDia': 'First day of the week',
    'settings.primeiroDiaDesc': 'Set the first day of the week for calendars',
    'settings.domingo': 'Sunday',
    'settings.segunda': 'Monday',
    'settings.prefSistema': 'System Preferences',
    'settings.segConta': 'Account Security',
    'settings.senhaAtual': 'Current Password',
    'settings.novaSenha': 'New Password',
    'settings.confirmarSenha': 'Confirm New Password',
    'settings.alterarSenha': 'Change Password',
    'settings.alterando': 'Changing...',
    'settings.suporteTitle': 'Need help?',
    'settings.suporteDesc': 'Our team is available to assist you via WhatsApp.',
    'settings.falarComSuporte': 'Talk to support',
    'help.titulo': 'Help and Support',
    'help.subtitulo': 'Learn at your own pace or talk to us.',
    'help.videosTag': 'Videos',
    'help.videosTitulo': 'YouTube tutorials',
    'help.videosDesc': 'Watch a step-by-step guide to every Financeiro Diário screen.',
    'help.videosBotao': 'Watch tutorials',
    'help.comunidadeTag': 'Community',
    'help.comunidadeTitulo': 'Financeiro Diário community',
    'help.comunidadeDesc': 'Ask questions and see how other people organize their business money.',
    'help.comunidadeBotao': 'Join the community',
    'help.suporteTag': 'Support',
    'help.suporteTitulo': 'Support',
    'help.suporteDesc': "Couldn't find the answer? Message the team on WhatsApp.",
    'help.suporteBotao': 'Talk to support',
    'settings.notifEmail': 'Email Notifications',
    'settings.notifEmailDesc': 'Receive important updates to your email',
    'settings.notifPush': 'Push Notifications',
    'settings.notifPushDesc': 'Receive notifications in the browser',
    'settings.relSemanal': 'Weekly Report',
    'settings.relSemanalDesc': 'Receive a weekly summary of your finances',
    'settings.alertasOrc': 'Budget Alerts',
    'settings.alertasOrcDesc': 'Be notified when you reach budget limits',
    'settings.notifConfig': 'Notification Settings',
    'settings.notifSalvas': '✓ Notification preferences saved.',
    'settings.nomeObrigatorio': 'Name is required.',
    'settings.emailObrigatorio': 'Email is required.',
    'settings.emailInvalido': 'Enter a valid email address.',
    'settings.perfilSalvo': 'Profile updated successfully.',
    'settings.erroSalvarPerfil': 'Error saving profile.',
    'settings.preencherCampos': 'Fill in all fields.',
    'settings.senhaMinCarac': 'New password must be at least 6 characters.',
    'settings.senhasNaoCoincidem': "Passwords don't match.",
    'settings.senhaAlterada': 'Password changed successfully.',
    'settings.erroAlterarSenha': 'Error changing password.',
    'settings.erroExcluirConta': 'Error deleting account.',
    'settings.zonaDangerTitle': 'Danger Zone',
    'settings.zonaDangerDesc': 'Irreversible actions that permanently affect your account.',
    'settings.excluirConta': 'Delete my account',
    'settings.excluirContaAviso': 'Type',
    'settings.excluirContaAvisoApos': 'to confirm the permanent deletion of your account:',
    'settings.excluirConfirmar': 'Confirm Deletion',
    'settings.excluindo': 'Deleting...',
    'settings.suaAssinatura': 'Your Subscription',
    'settings.planoAtual': 'Current Plan',
    'settings.semPlanoAtivo': 'No active plan',
    'settings.cobMensal': 'Monthly billing',
    'settings.cobAnual': 'Annual billing',
    'settings.mes': 'month',
    'settings.ano': 'year',
    'settings.transacoesPorMes': 'Transactions per month',
    'settings.funcionalidades': 'Features',
    'settings.cancelarAssinatura': 'Cancel Subscription',
    'settings.cancelarAssinaturaDesc': 'When you cancel, you will lose access to premium features at the end of the current period.',
    'settings.solicitarCancelamento': 'Request Cancellation',
    'settings.totalPago': 'Total paid',
    'settings.faturasPagas': 'Paid invoices',
    'settings.statusConta': 'Account status',
    'settings.emDia': 'Up to date',
    'settings.semPlano': 'No plan',
    'settings.historicoVazio': 'Detailed invoice history will be displayed here when available from the payment provider.',
    'settings.dadosFiscais': 'Tax Information',
    'settings.nomeRazaoSocial': 'Name / Company Name',
    'settings.endereco': 'Address',
    'settings.cep': 'ZIP Code',
    'settings.salvarDadosFiscais': 'Save Tax Information',
    'settings.dadosFiscaisSalvos': 'Tax data saved locally.',
    'common.anterior': 'Previous',
    'common.proxima': 'Next',
    'common.pagina': 'Page',
    'common.de': 'of',
    'common.buscar': 'Search',
    'common.buscando': 'Searching...',
    'common.semDados': 'No data for this period',
    'common.carregandoDados': 'Loading data...',
    'common.periodo': 'Period',
    'common.ate': 'to',
    'chart.fluxoCaixa': 'Cash Flow',
    'chart.ultimos6Meses': 'Last 6 months',
    'chart.ultimoAno': 'Last year',
    'chart.todoPeriodo': 'All time',
    'chart.tudo': 'All',
    'chart.receitas': 'Income',
    'chart.despesas': 'Expenses',
    'chart.semDadosFluxo': 'No cash flow data for this period',
    'chart.resultadoMensal': 'Monthly Result',
    'chart.receitaMinusDespesa': 'Income − Expense by month',
    'chart.resultado': 'Result',
    'chart.comparativoMensal': 'Monthly Comparison',
    'chart.receitasVsDespesas': 'Income vs Expenses by month',
    'chart.distribuicaoDespesas': 'Expense Distribution',
    'chart.distribuicaoReceitas': 'Income Distribution',
    'chart.porCategoria': 'By category',
    'chart.outros': 'Others',
    'chart.verMenos': 'See less',
    'chart.verTodas': 'See all',
    'chart.topCategorias': 'Top Expense Categories',
    'chart.maioresDespesas': 'Largest expenses by category',
    'chart.topReceitas': 'Top Income Categories',
    'chart.maioresReceitas': 'Largest income by category',
    'chart.fluxoAcumulado': 'Cumulative Cash Flow',
    'chart.evolucaoResultado': 'Result evolution over the period',
    'chart.saldoAcumulado': 'Cumulative Balance',
    'chart.positivo': 'Positive',
    'chart.negativo': 'Negative',
    'rt.transacoesRecentes': 'Recent Transactions',
    'rt.verTodas': 'See all',
    'rt.nenhumaTransacao': 'No recent transactions.',
    'rt.todasTransacoes': 'All Transactions',
    'rt.buscarPlaceholder': 'Search by amount, category, payment method...',
    'rt.transacoesEncontradas': '{{n}} transaction(s) found',
    'rt.nenhumaTrEncontrada': 'No transactions found.',
    'rt.hoje': 'Today',
    'rt.ontem': 'Yesterday',
    'rel.titulo': 'Reports',
    'rel.subtitulo': 'Generate and export detailed reports',
    'rel.exportarExcel': 'Export Excel',
    'rel.exportarPdf': 'Export PDF',
    'rel.filtros': 'Report Filters',
    'rel.tipoRelatorio': 'Report Type',
    'rel.granularidade': 'Granularity',
    'rel.dia': 'Day',
    'rel.mes': 'Month',
    'rel.ano': 'Year',
    'rel.dataInicio': 'Start Date',
    'rel.dataFim': 'End Date',
    'rel.categoria': 'Category',
    'rel.grupo': 'Group',
    'rel.formaPagamento': 'Payment Method',
    'rel.todas': 'All',
    'rel.gerarRelatorio': 'Generate Report',
    'rel.filiais': 'Businesses:',
    'rel.limpar': 'Clear ({{n}})',
    'rel.totalReceitas': 'Total Income',
    'rel.totalDespesas': 'Total Expenses',
    'rel.resultadoLiquido': 'Net Result',
    'rel.transacoes': 'Transactions',
    'rel.vsPeriodo': 'vs previous period',
    'rel.nenhumDado': 'No data found for the period.',
    'rel.dicaForaPeriodo': 'There are {{n}} entries matching these filters outside the selected period.',
    'rel.dicaNomeParecido': 'Within the period there are entries under similarly named categories:',
    'rel.dicaQtdLancamentos': '{{n}} entries',
    'rel.distribuicao': 'Distribution',
    'rel.total': 'Total:',
    'rel.detalhamentoPorFilial': 'Business Breakdown',
    'rel.pctTotal': '% of total',
    'rel.detalhamento': 'Breakdown',
    'rel.evolucaoFluxo': 'Cash Flow Evolution',
    'rel.porPeriodo': 'By period',
    'rel.resumoPeriodo': 'Period Summary',
    'rel.resultadoFinal': 'Final Result',
    'rel.evolucaoResultado': 'Result Evolution',
    'rel.principaisCategorias': 'Top Categories',
    'rel.subtotalReceitas': 'Income Subtotal',
    'rel.subtotalDespesas': 'Expense Subtotal',
    'rel.outrasCategorias': 'Others ({{n}})',
    'rel.principaisReceitas': 'Top Income Categories',
    'rel.principaisDespesas': 'Top Expense Categories',
    'rel.porValor': 'by value',
    'rel.gerandoRelatorio': 'Generating report...',
    'rel.errGerar': 'Error generating report. Please try again.',
    'rel.metrica': 'Metric',
    'rel.valor': 'Value',
    'rel.fonte': 'Source',
    'rel.type.monthlySummary': 'Monthly Summary',
    'rel.type.monthlySummaryDesc': 'Period overview',
    'rel.type.expByCategory': 'Expenses by Category',
    'rel.type.expByCategoryDesc': 'Expense analysis',
    'rel.type.incBySource': 'Income by Source',
    'rel.type.incBySourceDesc': 'Income analysis',
    'rel.type.cashflow': 'Cash Flow',
    'rel.type.cashflowDesc': 'Financial movements',
    'rel.type.incByFilial': 'Income by Business',
    'rel.type.incByFilialDesc': 'Income grouped by business',
    'rel.type.expByFilial': 'Expenses by Business',
    'rel.type.expByFilialDesc': 'Expenses grouped by business',
    'cat.receitas': 'Revenue',
    'cat.custos': 'Costs',
    'cat.despesasVariaveis': 'Variable Expenses',
    'cat.despesasFixas': 'Fixed Expenses',
    'cat.outrasDespesas': 'Other Expenses',
    'sub.vendasProdutos': 'Product Sales',
    'sub.vendasServicos': 'Service Sales',
    'sub.investimento': 'Investment',
    'sub.rendimentoAplicacoes': 'Investment Returns',
    'sub.materiaPrima': 'Raw Materials',
    'sub.embalagem': 'Packaging',
    'sub.insumos': 'Inputs',
    'sub.impostos': 'Taxes',
    'sub.marketing': 'Marketing Ads',
    'sub.comissao': 'Commission',
    'sub.servicoTerceiros': 'Third-party Services',
    'sub.aluguel': 'Rent',
    'sub.luz': 'Electricity',
    'sub.aguaEsgoto': 'Water & Sewage',
    'sub.internetTelefone': 'Internet & Phone',
    'sub.folhaPagamento': 'Payroll',
    'sub.valeTransporte': 'Transportation Voucher',
    'sub.valeCombustivel': 'Fuel Voucher',
    'sub.inss': 'Social Security (INSS)',
    'sub.fgts': 'Severance Fund (FGTS)',
    'sub.materialEscritorio': 'Office Supplies',
    'sub.contabilidade': 'Accounting',
    'sub.proLabore': 'Pro-labore',
    'sub.investimentos': 'Investments',
    'sub.tarifasBancarias': 'Bank Fees',
    'sub.juros': 'Interest',
    'sub.descontos': 'Discounts',
    'fp.pix': 'Pix',
    'fp.dinheiro': 'Cash',
    'fp.transferenciaBancaria': 'Bank Transfer',
    'fp.boleto': 'Bank Slip',
    'fp.cheque': 'Check',
    'fp.cartaoCredito': 'Credit Card',
    'fp.cartaoDebito': 'Debit Card',
    'fp.duplicata': 'Duplicate',
    'fp.deposito': 'Deposit',
    'fp.acordoParcelado': 'Parceled Agreement',
    'fp.notaPromissoria': 'Promissory Note',
    'fp.debitoAutomatico': 'Automatic Debit',
    'fp.cartaoCorporativo': 'Corporate Card',
    'fp.paypalWise': 'PayPal Wise',
    'fp.depositoIdentificado': 'Identified Deposit',
    'fp.depositoJudicial': 'Judicial Deposit',
    'modal.subcategoria.titulo': 'New Category',
    'modal.subcategoria.categoriaPai': 'Group',
    'modal.subcategoria.subcategoria': 'Category',
    'modal.subcategoria.novaCategoria': 'New group name',
    'modal.subcategoria.novaSubcategoria': 'New category name',
    'modal.subcategoria.selecionePesquise': 'Select or search...',
    'modal.subcategoria.carregando': 'Loading...',
    'modal.subcategoria.concluir': 'Confirm',
    'modal.subcategoria.erroCategoria': 'Enter the group name.',
    'modal.subcategoria.erroSubcategoria': 'Enter the category name.',
    'modal.subcategoria.erroSelecao': 'Select the group and the category.',
    'modal.subcategoria.erroCarregarSubs': 'Error loading categories.',
};

const es: Record<keyof typeof ptBR, string> = {
    'nav.menu': 'Inicio',
    'nav.lancarReceitas': 'Registrar Ingresos',
    'nav.lancarDespesas': 'Registrar Gastos',
    'nav.historico': 'Historial de Transacciones',
    'nav.importarPlanilha': 'Importar Planilla',
    'nav.cashflow': 'Flujo de Caja',
    'nav.graficos': 'Gráficos',
    'nav.relatorios': 'Informes',
    'nav.planoContas': 'Plan de Cuentas',
    'nav.configuracoes': 'Configuración',
    'nav.ganhe': 'Gana 1 Mes Gratis',
    'nav.ajuda': 'Ayuda y Soporte',
    'nav.gestaoUsuarios': 'Gestión de Usuarios',
    'nav.filialAtiva': 'Negocio activo',
    'nav.selecionarFilial': 'Seleccionar negocio',
    'nav.expandirMenu': 'Expandir menú',
    'nav.recolherMenu': 'Contraer menú',
    'nav.fecharMenu': 'Cerrar menú',
    'nav.abrirMenu': 'Abrir menú',
    'header.configuracoes': 'Configuración',
    'header.sair': 'Cerrar sesión',
    'header.negocio': 'Negocio',
    'header.somenteVisualizacao': 'Solo visualización',
    'header.trocarNegocio': 'Cambiar de negocio',
    'header.todosNegocios': 'Todos los negocios',
    'header.selecionarNegocio': 'Seleccionar',
    'cashflow.subtituloTabela': 'Ingresos y gastos agrupados por categoría',
    'cashflow.scrollHint': 'Desliza la tabla hacia el lado para ver todos los meses',
    'cashflow.periodoExibido': 'Período mostrado',
    'cashflow.anoInteiro': 'Año completo',
    'cashflow.compararMesAnterior': 'Comparar con el mes anterior',
    'cashflow.mostrarMesesZerados': 'Mostrar meses en cero',
    'cashflow.analiseHorizontal': 'Análisis horizontal (% del ingreso)',
    'cashflow.exportarPdf': 'Exportar PDF',
    'cashflow.exportarExcel': 'Exportar Excel',
    'cashflow.semMovimento': 'Ningún mes con movimiento en este año.',
    'cashflow.notaAnaliseHorizontal': 'El análisis horizontal muestra cada valor como porcentaje de los ingresos del mismo mes; un mes sin ingresos aparece como "–".',
    'cashflow.notaComparacao': 'Δ% compara cada mes con el anterior. Enero queda sin comparación porque el mes anterior está fuera del año consultado, y un mes con base cero tampoco.',
    'cashflow.notaMesesOcultos': '{{n}} mes(es) sin movimiento ocultos.',
    'common.carregando': 'Cargando...',
    'common.ilimitado': 'Ilimitado',
    'common.salvando': 'Guardando...',
    'common.cancelar': 'Cancelar',
    'common.fechar': 'Cerrar',
    'common.limpar': 'Limpiar',
    'common.confirmar': 'Confirmar',
    'common.voltar': 'Volver',
    'common.salvar': 'Guardar',
    'common.salvarAlteracoes': 'Guardar Cambios',
    'common.editar': 'Editar',
    'common.excluir': 'Eliminar',
    'common.adicionar': 'Agregar',
    'common.selecione': 'Seleccione...',
    'common.sim': 'Sí',
    'common.nao': 'No',
    'common.acoes': 'Acciones',
    'common.nome': 'Nombre',
    'common.tipo': 'Tipo',
    'common.descricao': 'Descripción',
    'common.status': 'Estado',
    'common.ativo': 'Activo',
    'common.inativo': 'Inactivo',
    'common.entrada': 'Ingreso',
    'common.saida': 'Gasto',
    'common.ambos': 'Ambos',
    'common.verMais': 'ver más',
    'common.semResultados': 'No se encontraron resultados.',
    'common.erroCampos': 'Complete todos los campos obligatorios',
    'common.erroCarregar': 'No se pudieron cargar los datos. Inténtalo de nuevo en unos instantes.',
    'common.categoria': 'Categoría',   
    'common.saldo': 'Saldo',
    'login.titulo': '¡Bienvenido de nuevo!',
    'login.subtitulo': 'Ingresa tus credenciales para acceder a tu cuenta',
    'login.email': 'Correo electrónico',
    'login.senha': 'Contraseña',
    'login.entrar': 'Iniciar sesión',
    'login.esqueceuSenha': '¿Olvidaste tu contraseña?',
    'login.semConta': '¿No tienes una cuenta?',
    'login.cadastrar': 'Regístrate gratis',
    'login.erroCampos': 'Por favor, complete todos los campos.',
    'login.erroCredenciais': 'Credenciales inválidas. Inténtalo de nuevo.',
    'login.voltarLogin': 'Volver al inicio de sesión',
    'login.forgotTitulo': 'Restablecer contraseña',
    'login.forgotSubtitulo': 'Ingresa tu correo para recibir el enlace de restablecimiento',
    'login.forgotEnviar': 'Enviar enlace',
    'login.forgotSucesso': 'Si este correo está registrado, recibirás un enlace para restablecer tu contraseña en breve.',
    'login.forgotEmailObrigatorio': 'Por favor, ingresa tu correo.',
    'login.forgotErro': 'Error al enviar el correo. Inténtalo de nuevo.',
    // ResetPassword
    'resetPassword.titulo': 'Nueva contraseña',
    'resetPassword.subtitulo': 'Crea una nueva contraseña para tu cuenta',
    'resetPassword.novaSenha': 'Nueva contraseña',
    'resetPassword.confirmarSenha': 'Confirmar nueva contraseña',
    'resetPassword.salvar': 'Guardar nueva contraseña',
    'resetPassword.sucesso': '¡Contraseña restablecida con éxito! Ya puedes iniciar sesión.',
    'resetPassword.erroCampos': 'Por favor, complete todos los campos.',
    'resetPassword.erroSenhasDiferentes': 'Las contraseñas no coinciden.',
    'resetPassword.erroSenhaFraca': 'La contraseña debe tener al menos 6 caracteres.',
    'resetPassword.erroTokenInvalido': 'Enlace de restablecimiento inválido.',
    'resetPassword.erroTokenExpirado': 'Este enlace ha expirado o ya fue utilizado. Solicita uno nuevo.',
    // Register
    'register.titulo': 'Crea tu cuenta',
    'register.subtitulo': 'Completa los datos a continuación para comenzar',
    'register.nomeCompleto': 'Nombre completo',
    'register.email': 'Correo electrónico',
    'register.whatsapp': 'WhatsApp',
    'register.whatsappHint': 'Con código de país + código de área + número (solo dígitos). Ej: 5511999998888',
    'register.senha': 'Contraseña',
    'register.confirmarSenha': 'Confirmar contraseña',
    'register.criar': 'Crear cuenta',
    'register.temConta': '¿Ya tienes una cuenta?',
    'register.entrar': 'Iniciar sesión',
    'register.erroNomeObrigatorio': 'Ingresa tu nombre completo.',
    'register.erroNomeInvalido': 'Ingresa un nombre válido (solo letras y espacios).',
    'register.erroEmailObrigatorio': 'Ingresa tu correo electrónico.',
    'register.erroEmailInvalido': 'Ingresa un correo electrónico válido.',
    'register.erroWhatsappObrigatorio': 'Ingresa tu número de WhatsApp.',
    'register.erroWhatsappInvalido': 'Este número de WhatsApp parece inválido. Verifica el código de país y de área.',
    'register.erroSenhaObrigatoria': 'Crea una contraseña.',
    'register.erroSenhaFraca': 'Tu contraseña aún no cumple todos los requisitos a continuación.',
    'register.erroConfirmarSenhaObrigatoria': 'Confirma tu contraseña.',
    'register.mostrarSenha': 'Mostrar contraseña',
    'register.ocultarSenha': 'Ocultar contraseña',
    'register.senhaReqMinLength': 'Mínimo 8 caracteres',
    'register.senhaReqUppercase': 'Una letra mayúscula',
    'register.senhaReqLowercase': 'Una letra minúscula',
    'register.senhaReqNumber': 'Un número',
    'register.senhaReqSpecial': 'Un carácter especial',
    'register.erroCampos': 'Por favor, completa todos los campos.',
    'register.erroSenhasCoincidem': 'Las contraseñas no coinciden.',
    'register.erroSenhaMin': 'La contraseña debe tener al menos 6 caracteres.',
    'register.erroWhatsapp': 'Ingresa WhatsApp con código de país + código de área + número (solo dígitos, ej: 5511999998888).',
    'register.erroEmailExiste': 'Este correo ya está registrado.',
    'register.erroGenerico': 'Error al crear cuenta. Inténtalo de nuevo.',
    'register.emailPlaceholder': 'seu.email@ejemplo.com',
    'home.titulo': 'Inicio',
    'home.saudacao': 'Hola {{name}}, ¿qué vamos a hacer ahora?',
    'home.lancar': 'Registrar',
    'home.receitas': 'Ingresos',
    'home.despesas': 'Gastos',
    'home.historico': 'Historial de Transacciones',
    'home.cashflow': 'Flujo de Caja',
    'home.graficos': 'Gráficos',
    'home.relatorios': 'Informes',
    'receita.titulo': 'Registrar Ingreso',
    'receita.subtitulo': 'Registra tus entradas financieras',
    'receita.dataRecebimento': 'Fecha de Recepción',
    'receita.tipo': 'Tipo de Ingreso',
    'receita.formaPagamento': 'Forma de Pago',
    'receita.valor': 'Monto Total',
    'receita.infoAdicionais': 'Información Adicional',
    'receita.placeholder': 'Notas, detalles de la transacción...',
    'receita.btn': 'Registrar Ingreso',
    'receita.sucesso': '¡Ingreso registrado con éxito!',
    'receita.erroSalvar': 'Error al guardar. Inténtalo de nuevo.',
    'despesa.titulo': 'Registrar Gasto',
    'despesa.subtitulo': 'Registra tus salidas financieras',

    // Plano Gratuito (MAN-364)
    'planoGratuito.contagemTitulo': 'Estás en el plan Gratuito con {{limite}} registros',
    'planoGratuito.contagem': 'Conteo ({{usados}}/{{limite}})',
    'planoGratuito.limiteTitulo': '¡Alcanzaste el límite de registros!',
    'planoGratuito.limitePrefixo': 'Tu',
    'planoGratuito.limiteDestaque': 'límite es de {{limite}} registros',
    'planoGratuito.limiteSufixo': '.',
    'planoGratuito.limiteModal': 'Tu límite es de {{limite}} registros, mejora tu plan para tener más.',
    'planoGratuito.fazerUpgrade': 'Mejorar plan',
    'planoGratuito.fechar': 'Cerrar aviso',
    'despesa.dataPagamento': 'Fecha de Pago',
    'despesa.tipo': 'Tipo de Gasto',
    'despesa.btn': 'Registrar Gasto',
    'despesa.sucesso': '¡Gasto registrado con éxito!',
    'despesa.erroSalvar': 'Error al guardar. Inténtalo de nuevo.',
    'lanc.titulo': 'Historial de Transacciones',
    'lanc.subtitulo': 'Gestiona y visualiza todas tus transacciones',
    'lanc.todos': 'Todos',
    'lanc.receitas': 'Ingresos',
    'lanc.despesas': 'Gastos',
    'lanc.data': 'Fecha',
    'lanc.categoria': 'Categoría',
    'lanc.tipo': 'Tipo',
    'lanc.grupo': 'Grupo',
    'lanc.buscarCategoriaOuGrupo': 'Buscar categoría o grupo...',
    'lanc.tipoLancamento': 'Tipo',
    'lanc.todosGrupos': 'Todos los grupos',
    'lanc.buscarCategoria': 'Buscar por categoría...',
    'lanc.formaPag': 'Pago',
    'lanc.valor': 'Monto',
    'lanc.obs': 'Notas',
    'lanc.descricao': 'Descripción',
    'lanc.lancadoPor': 'Registrado por',
    'lanc.dataDe': 'Desde',
    'lanc.dataAte': 'Hasta',
    'lanc.receita': 'Ingreso',
    'lanc.gasto': 'Gasto',
    'lanc.totalReceitas': 'Total Ingresos',
    'lanc.totalGastos': 'Total Gastos',
    'lanc.resultado': 'Resultado',
    'lanc.lancamentos': 'Transacciones',
    'lanc.novoLancamento': 'Nueva Transacción',
    'lanc.editarLancamento': 'Editar Transacción',
    'lanc.confirmarExcluir': '¿Estás seguro de que deseas eliminar esta transacción?',
    'lanc.erroSalvar': 'Error al guardar la transacción',
    'lanc.erroExcluir': 'Error al eliminar la transacción',
    'lanc.erroCarregar': 'No se pudieron cargar las transacciones. Inténtalo de nuevo en unos instantes.',
    'lanc.buscarSubcategoria': 'Buscar por subcategoría...',
    'lanc.todasCategorias': 'Todas las categorías',
    'lanc.todosMeses': 'Todos los meses',
    'lanc.todosAnos': 'Todos los años',
    'lanc.filial': 'Negocio',
    'lanc.nenhumEncontrado': 'No se encontraron transacciones',
    'lanc.observacao': 'Nota',
    'lanc.formaPagEx': 'Ej: PIX, Tarjeta de Crédito...',
    'lanc.obsPlaceholder': 'Notas sobre la transacción...',
    'lanc.cadastrar': 'Crear',
    'lanc.ordenarPorCriacao': 'Por registro',
    'lanc.ordenarPorData': 'Por fecha',
    'plano.titulo': 'Plan de Cuentas',
    'plano.subtitulo': 'Gestiona grupos, categorías y formas de pago',
    'plano.faixaEmpresa': 'Plan de cuentas de la empresa {{empresa}}',
    'plano.grupos': 'Grupos',
    'plano.novoGrupo': 'Nuevo grupo',
    'plano.editarGrupo': 'Editar grupo',
    'plano.grupoVinculado': 'Grupo',
    'plano.pesquisarGrupo': 'Buscar grupo...',
    'plano.receitas': 'Ingresos',
    'plano.despesas': 'Gastos',
    'plano.catCount': '{{n}} categoría',
    'plano.catCount_plural': '{{n}} categorías',
    'plano.grupoCount': '{{n}} grupo',
    'plano.grupoCount_plural': '{{n}} grupos',
    'plano.resumoSecao': '{{cat}} en {{grp}}',
    'plano.nenhumGrupo': 'No hay grupos registrados',
    'plano.criarPrimeiroGrupo': 'Crear primer grupo',
    'plano.nenhumaCatNoGrupo': 'No hay categorías en este grupo',
    'plano.organizarGrupos': 'Organizar grupos',
    'plano.organizarAjuda': 'Arrastra las categorías para moverlas entre grupos. Solo se puede mover dentro de ingresos o dentro de gastos.',
    'plano.soltarAqui': 'Suelta aquí para mover a este grupo',
    'plano.tipoIncompativel': 'Solo se pueden mover categorías entre grupos del mismo tipo (ingresos o gastos).',
    'plano.pendentes': '{{n}} cambio sin guardar',
    'plano.pendentes_plural': '{{n}} cambios sin guardar',
    'plano.salvarOrganizacao': 'Guardar organización',
    'plano.descartarOrganizacao': 'Descartar',
    'plano.organizacaoSalva': 'Organización guardada. El Flujo de Caja ya refleja los nuevos grupos.',
    'plano.erroMover': 'No se pudo guardar la organización.',
    'plano.confirmarSairSemSalvar': 'Organizaste los grupos pero aún no guardaste. ¿Deseas guardar ahora?',
    'plano.confirmarDescartar': '¿Descartar los cambios de organización?',
    'plano.categorias': 'Categorías',
    'plano.formasPagamento': 'Formas de Pago',
    'plano.novaCategoria': 'Nueva Categoría',
    'plano.novaFormaPagamento': 'Nueva Forma de Pago',
    'plano.editarCategoria': 'Editar Categoría',
    'plano.editarFormaPagamento': 'Editar Forma de Pago',
    'plano.nomeCategoria': 'Nombre de Categoría',
    'plano.nomeFormaPagamento': 'Nombre de Forma de Pago',
    'plano.confirmarExcluir': '¿Estás seguro de que deseas eliminar este elemento?',
    'plano.confirmarExcluirGrupo': 'Eliminar el grupo "{{nome}}" también elimina las {{n}} categoría(s) que contiene. ¿Continuar?',
    'plano.erroSalvar': 'Error al guardar. Verifica los datos e inténtalo de nuevo.',
    'plano.erroExcluir': 'Error al eliminar. Este elemento puede estar en uso.',
    'plano.naoExcluirVinculado': 'No se puede eliminar "{{nome}}": hay {{n}} movimiento(s) vinculado(s). Puedes renombrarlo (el nombre se actualizará en los movimientos), pero no eliminarlo.',
    'plano.exclusaoBloqueada': 'Eliminación bloqueada: hay movimientos vinculados. Puedes renombrarlo.',
    'plano.vinculadosInfo': 'Este elemento tiene {{n}} movimiento(s) vinculado(s). Cambiar el nombre los actualizará todos.',
    'plano.entradas': 'Ingresos',
    'plano.saidas': 'Gastos',
    'plano.descricaoOpcional': 'Descripción (opcional)',
    'cashflow.titulo': 'Flujo de Caja',
    'cashflow.subtitulo': 'Estado de Resultados',
    'cashflow.dataInicio': 'Fecha inicio',
    'cashflow.dataFim': 'Fecha fin',
    'cashflow.aplicar': 'Aplicar',
    'settings.titulo': 'Configuración',
    'settings.subtitulo': 'Gestiona tus preferencias e información de cuenta',
    'settings.perfil': 'Perfil',
    'settings.preferencias': 'Preferencias',
    'settings.notificacoes': 'Notificaciones',
    'settings.seguranca': 'Seguridad',
    'settings.assinatura': 'Suscripción',
    'settings.historicoPagamentos': 'Historial de Pagos',
    'settings.infosPerfil': 'Información del Perfil',
    'settings.nomeCompleto': 'Nombre completo',
    'settings.prefsSalvas': '✓ Preferencias guardadas automáticamente.',
    'settings.modoEscuro': 'Modo Oscuro',
    'settings.modoEscuroDesc': 'Activa el tema oscuro para mejor visualización nocturna',
    'settings.moedaPadrao': 'Moneda Predeterminada',
    'settings.moedaPadraoDesc': 'Selecciona la moneda para mostrar los valores',
    'settings.idioma': 'Idioma',
    'settings.idiomaDesc': 'Selecciona el idioma de la interfaz',
    'settings.primeiroDia': 'Primer día de la semana',
    'settings.primeiroDiaDesc': 'Establece el primer día de la semana para los calendarios',
    'settings.domingo': 'Domingo',
    'settings.segunda': 'Lunes',
    'settings.prefSistema': 'Preferencias del Sistema',
    'settings.segConta': 'Seguridad de la Cuenta',
    'settings.senhaAtual': 'Contraseña Actual',
    'settings.novaSenha': 'Nueva Contraseña',
    'settings.confirmarSenha': 'Confirmar Nueva Contraseña',
    'settings.alterarSenha': 'Cambiar Contraseña',
    'settings.alterando': 'Cambiando...',
    'settings.suporteTitle': '¿Necesitas ayuda?',
    'settings.suporteDesc': 'Nuestro equipo está disponible para atenderte por WhatsApp.',
    'settings.falarComSuporte': 'Hablar con soporte',
    'help.titulo': 'Ayuda y Soporte',
    'help.subtitulo': 'Aprende a tu ritmo o habla con nosotros.',
    'help.videosTag': 'Videos',
    'help.videosTitulo': 'Tutoriales en YouTube',
    'help.videosDesc': 'Mira el paso a paso de cada pantalla de Financeiro Diário.',
    'help.videosBotao': 'Ver tutoriales',
    'help.comunidadeTag': 'Comunidad',
    'help.comunidadeTitulo': 'Comunidad de Financeiro Diário',
    'help.comunidadeDesc': 'Resuelve dudas y mira cómo otras personas organizan el dinero del negocio.',
    'help.comunidadeBotao': 'Unirme a la comunidad',
    'help.suporteTag': 'Atención',
    'help.suporteTitulo': 'Soporte',
    'help.suporteDesc': '¿No encontraste la respuesta? Escribe al equipo por WhatsApp.',
    'help.suporteBotao': 'Hablar con soporte',
    'settings.notifEmail': 'Notificaciones por Correo',
    'settings.notifEmailDesc': 'Recibe actualizaciones importantes en tu correo',
    'settings.notifPush': 'Notificaciones Push',
    'settings.notifPushDesc': 'Recibe notificaciones en el navegador',
    'settings.relSemanal': 'Informe Semanal',
    'settings.relSemanalDesc': 'Recibe un resumen semanal de tus finanzas',
    'settings.alertasOrc': 'Alertas de Presupuesto',
    'settings.alertasOrcDesc': 'Sé notificado cuando alcances límites de presupuesto',
    'settings.notifConfig': 'Configuración de Notificaciones',
    'settings.notifSalvas': '✓ Preferencias de notificación guardadas.',
    'settings.nomeObrigatorio': 'El nombre es obligatorio.',
    'settings.emailObrigatorio': 'El correo es obligatorio.',
    'settings.emailInvalido': 'Ingresa un correo válido.',
    'settings.perfilSalvo': 'Perfil actualizado con éxito.',
    'settings.erroSalvarPerfil': 'Error al guardar el perfil.',
    'settings.preencherCampos': 'Complete todos los campos.',
    'settings.senhaMinCarac': 'La nueva contraseña debe tener al menos 6 caracteres.',
    'settings.senhasNaoCoincidem': 'Las contraseñas no coinciden.',
    'settings.senhaAlterada': 'Contraseña cambiada con éxito.',
    'settings.erroAlterarSenha': 'Error al cambiar la contraseña.',
    'settings.erroExcluirConta': 'Error al eliminar cuenta.',
    'settings.zonaDangerTitle': 'Zona de Peligro',
    'settings.zonaDangerDesc': 'Acciones irreversibles que afectan permanentemente tu cuenta.',
    'settings.excluirConta': 'Eliminar mi cuenta',
    'settings.excluirContaAviso': 'Escribe',
    'settings.excluirContaAvisoApos': 'para confirmar la eliminación permanente de tu cuenta:',
    'settings.excluirConfirmar': 'Confirmar Eliminación',
    'settings.excluindo': 'Eliminando...',
    'settings.suaAssinatura': 'Tu Suscripción',
    'settings.planoAtual': 'Plan Actual',
    'settings.semPlanoAtivo': 'Sin plan activo',
    'settings.cobMensal': 'Facturación mensual',
    'settings.cobAnual': 'Facturación anual',
    'settings.mes': 'mes',
    'settings.ano': 'año',
    'settings.transacoesPorMes': 'Transacciones por mes',
    'settings.funcionalidades': 'Funcionalidades',
    'settings.cancelarAssinatura': 'Cancelar Suscripción',
    'settings.cancelarAssinaturaDesc': 'Al cancelar, perderás acceso a las funciones premium al final del período actual.',
    'settings.solicitarCancelamento': 'Solicitar Cancelación',
    'settings.totalPago': 'Total pagado',
    'settings.faturasPagas': 'Facturas pagadas',
    'settings.statusConta': 'Estado de la cuenta',
    'settings.emDia': 'Al día',
    'settings.semPlano': 'Sin plan',
    'settings.historicoVazio': 'El historial detallado de facturas se mostrará aquí cuando esté disponible del proveedor de pagos.',
    'settings.dadosFiscais': 'Datos Fiscales',
    'settings.nomeRazaoSocial': 'Nombre / Razón Social',
    'settings.endereco': 'Dirección',
    'settings.cep': 'Código Postal',
    'settings.salvarDadosFiscais': 'Guardar Datos Fiscales',
    'settings.dadosFiscaisSalvos': 'Datos fiscales guardados localmente.',
    'common.anterior': 'Anterior',
    'common.proxima': 'Siguiente',
    'common.pagina': 'Página',
    'common.de': 'de',
    'common.buscar': 'Buscar',
    'common.buscando': 'Buscando...',
    'common.semDados': 'Sin datos para este período',
    'common.carregandoDados': 'Cargando datos...',
    'common.periodo': 'Período',
    'common.ate': 'hasta',
    'common.ano': 'Año',
    'common.anoAtual': 'Año actual',
    'chart.fluxoCaixa': 'Flujo de Caja',
    'chart.ultimos6Meses': 'Últimos 6 meses',
    'chart.ultimoAno': 'Último año',
    'chart.todoPeriodo': 'Todo el período',
    'chart.tudo': 'Todo',
    'chart.receitas': 'Ingresos',
    'chart.despesas': 'Gastos',
    'chart.semDadosFluxo': 'Sin datos de flujo de caja para este período',
    'chart.resultadoMensal': 'Resultado Mensual',
    'chart.receitaMinusDespesa': 'Ingreso − Gasto por mes',
    'chart.resultado': 'Resultado',
    'chart.comparativoMensal': 'Comparativo Mensual',
    'chart.receitasVsDespesas': 'Ingresos vs Gastos por mes',
    'chart.distribuicaoDespesas': 'Distribución de Gastos',
    'chart.distribuicaoReceitas': 'Distribución de Ingresos',
    'chart.porCategoria': 'Por categoría',
    'chart.outros': 'Otros',
    'chart.verMenos': 'Ver menos',
    'chart.verTodas': 'Ver todas',
    'chart.topCategorias': 'Top Categorías de Gastos',
    'chart.maioresDespesas': 'Mayores gastos por categoría',
    'chart.topReceitas': 'Top Categorías de Ingresos',
    'chart.maioresReceitas': 'Mayores ingresos por categoría',
    'chart.fluxoAcumulado': 'Flujo Acumulado',
    'chart.evolucaoResultado': 'Evolución del resultado a lo largo del período',
    'chart.saldoAcumulado': 'Saldo Acumulado',
    'chart.positivo': 'Positivo',
    'chart.negativo': 'Negativo',
    'rt.transacoesRecentes': 'Transacciones Recientes',
    'rt.verTodas': 'Ver todas',
    'rt.nenhumaTransacao': 'No hay transacciones recientes.',
    'rt.todasTransacoes': 'Todas las Transacciones',
    'rt.buscarPlaceholder': 'Buscar por monto, categoría, forma de pago...',
    'rt.transacoesEncontradas': '{{n}} transacción(es) encontrada(s)',
    'rt.nenhumaTrEncontrada': 'No se encontraron transacciones.',
    'rt.hoje': 'Hoy',
    'rt.ontem': 'Ayer',
    'rel.titulo': 'Informes',
    'rel.subtitulo': 'Genera y exporta informes detallados',
    'rel.exportarExcel': 'Exportar Excel',
    'rel.exportarPdf': 'Exportar PDF',
    'rel.filtros': 'Filtros del Informe',
    'rel.tipoRelatorio': 'Tipo de Informe',
    'rel.granularidade': 'Granularidad',
    'rel.dia': 'Día',
    'rel.mes': 'Mes',
    'rel.ano': 'Año',
    'rel.dataInicio': 'Fecha Inicio',
    'rel.dataFim': 'Fecha Fin',
    'rel.categoria': 'Categoría',
    'rel.grupo': 'Grupo',
    'rel.formaPagamento': 'Forma de Pago',
    'rel.todas': 'Todas',
    'rel.gerarRelatorio': 'Generar Informe',
    'rel.filiais': 'Negocios:',
    'rel.limpar': 'Limpiar ({{n}})',
    'rel.totalReceitas': 'Total Ingresos',
    'rel.totalDespesas': 'Total Gastos',
    'rel.resultadoLiquido': 'Resultado Neto',
    'rel.transacoes': 'Transacciones',
    'rel.vsPeriodo': 'vs período anterior',
    'rel.nenhumDado': 'No se encontraron datos para el período.',
    'rel.dicaForaPeriodo': 'Existen {{n}} registros con estos filtros fuera del período seleccionado.',
    'rel.dicaNomeParecido': 'En el período hay registros en categorías con nombre parecido:',
    'rel.dicaQtdLancamentos': '{{n}} registros',
    'rel.distribuicao': 'Distribución',
    'rel.total': 'Total:',
    'rel.detalhamentoPorFilial': 'Desglose por Negocio',
    'rel.pctTotal': '% del total',
    'rel.detalhamento': 'Desglose',
    'rel.evolucaoFluxo': 'Evolución del Flujo de Caja',
    'rel.porPeriodo': 'Por período',
    'rel.resumoPeriodo': 'Resumen del Período',
    'rel.resultadoFinal': 'Resultado Final',
    'rel.evolucaoResultado': 'Evolución del Resultado',
    'rel.principaisCategorias': 'Principales Categorías',
    'rel.subtotalReceitas': 'Subtotal Ingresos',
    'rel.subtotalDespesas': 'Subtotal Gastos',
    'rel.outrasCategorias': 'Otros ({{n}})',
    'rel.principaisReceitas': 'Principales Ingresos',
    'rel.principaisDespesas': 'Principales Gastos',
    'rel.porValor': 'por valor',
    'rel.gerandoRelatorio': 'Generando informe...',
    'rel.errGerar': 'Error al generar el informe. Inténtalo de nuevo.',
    'rel.metrica': 'Métrica',
    'rel.valor': 'Valor',
    'rel.fonte': 'Fuente',
    'rel.type.monthlySummary': 'Resumen Mensual',
    'rel.type.monthlySummaryDesc': 'Visión general del período',
    'rel.type.expByCategory': 'Gastos por Categoría',
    'rel.type.expByCategoryDesc': 'Análisis de gastos',
    'rel.type.incBySource': 'Ingresos por Fuente',
    'rel.type.incBySourceDesc': 'Análisis de ingresos',
    'rel.type.cashflow': 'Flujo de Caja',
    'rel.type.cashflowDesc': 'Movimientos financieros',
    'rel.type.incByFilial': 'Ingresos por Negocio',
    'rel.type.incByFilialDesc': 'Ingresos agrupados por negocio',
    'rel.type.expByFilial': 'Gastos por Negocio',
    'rel.type.expByFilialDesc': 'Gastos agrupados por negocio',
    'cat.receitas': 'Ingresos',
    'cat.custos': 'Costos',
    'cat.despesasVariaveis': 'Gastos Variables',
    'cat.despesasFixas': 'Gastos Fijos',
    'cat.outrasDespesas': 'Otros Gastos',
    'sub.vendasProdutos': 'Venta de Productos',
    'sub.vendasServicos': 'Venta de Servicios',
    'sub.investimento': 'Inversión',
    'sub.rendimentoAplicacoes': 'Rendimiento de Inversiones',
    'sub.materiaPrima': 'Materia Prima',
    'sub.embalagem': 'Embalaje',
    'sub.insumos': 'Insumos',
    'sub.impostos': 'Impuestos',
    'sub.marketing': 'Gastos en publicidad',
    'sub.comissao': 'Comisión',
    'sub.servicoTerceiros': 'Servicios de terceros',
    'sub.aluguel': 'Alquiler',
    'sub.luz': 'Electricidad',
    'sub.aguaEsgoto': 'Agua y alcantarillado',
    'sub.internetTelefone': 'Internet y Teléfono',
    'sub.folhaPagamento': 'Nómina',
    'sub.valeTransporte': 'Vale de Transporte',
    'sub.valeCombustivel': 'Vale de Combustible',
    'sub.inss': 'Seguridad Social',
    'sub.fgts': 'Fondo de Garantía',
    'sub.materialEscritorio': 'Material de Oficina',
    'sub.contabilidade': 'Contabilidad',
    'sub.proLabore': 'Pro-labore',
    'sub.investimentos': 'Inversiones',
    'sub.tarifasBancarias': 'Tarifas Bancarias',
    'sub.juros': 'Intereses',
    'sub.descontos': 'Descuentos',
    'fp.pix': 'Pix',
    'fp.dinheiro': 'Efectivo',
    'fp.transferenciaBancaria': 'Transferencia Bancaria',
    'fp.boleto': 'Boleta',
    'fp.cheque': 'Cheque',
    'fp.cartaoCredito': 'Tarjeta de Crédito',
    'fp.cartaoDebito': 'Tarjeta de Débito',
    'fp.duplicata': 'Duplicado',
    'fp.deposito': 'Depósito',
    'fp.acordoParcelado': 'Acuerdo en Cuotas',
    'fp.notaPromissoria': 'Pagaré',
    'fp.debitoAutomatico': 'Débito Automático',
    'fp.cartaoCorporativo': 'Tarjeta Corporativa',
    'fp.paypalWise': 'PayPal Wise',
    'fp.depositoIdentificado': 'Depósito Identificado',
    'fp.depositoJudicial': 'Depósito Judicial',
    'modal.subcategoria.titulo': 'Nueva Categoría',
    'modal.subcategoria.categoriaPai': 'Grupo',
    'modal.subcategoria.subcategoria': 'Categoría',
    'modal.subcategoria.novaCategoria': 'Nombre del nuevo grupo',
    'modal.subcategoria.novaSubcategoria': 'Nombre de la nueva categoría',
    'modal.subcategoria.selecionePesquise': 'Seleccione o busque...',
    'modal.subcategoria.carregando': 'Cargando...',
    'modal.subcategoria.concluir': 'Confirmar',
    'modal.subcategoria.erroCategoria': 'Ingrese el nombre del grupo.',
    'modal.subcategoria.erroSubcategoria': 'Ingrese el nombre de la categoría.',
    'modal.subcategoria.erroSelecao': 'Seleccione el grupo y la categoría.',
    'modal.subcategoria.erroCarregarSubs': 'Error al cargar categorías.',
};

export const translations: Record<Language, Record<string, string>> = {
    'pt-BR': ptBR,
    'en-US': enUS,
    'es': es,
};
